/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2024 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ServicePopupDialogConnect } from './ServicePopupDialogConnect';
import { timeSeriesSelectors, timeSeriesActions } from '../../../store';
import type { TimeSeriesRootState } from '../../../store/types';

interface ServicePopupConnectProps {
  panelId: string;
}

export const ServicePopupConnect: React.FC<ServicePopupConnectProps> = ({
  panelId,
}: ServicePopupConnectProps) => {
  const dispatch = useDispatch();

  const { isOpen, url, serviceId, variant } = useSelector(
    (store: TimeSeriesRootState) =>
      timeSeriesSelectors.getServicePopupDetails(store, panelId),
  );

  const setServicePopupClosed = React.useCallback((): void => {
    dispatch(timeSeriesActions.closeServicePopup({ panelId }));
  }, [dispatch, panelId]);

  if (!isOpen) {
    return null;
  }

  return (
    <ServicePopupDialogConnect
      isOpen={isOpen}
      panelId={panelId}
      serviceId={serviceId}
      setServicePopupClosed={setServicePopupClosed}
      url={url}
      variant={variant}
    />
  );
};
